/**
 * Mobil bundnavigation ("LAB3D Erhverv"): hvid bar med hairline-topborder og
 * safe-area. 5 faner: Hjem, Katalog, Kurv (med antal-badge), Ordrer, Konto.
 * Hurtig bestilling/scan bor inde i kurven. Aktiv = navy ikon+label,
 * inaktiv = ink-3. Touch targets ≥44px.
 */
import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, ShoppingCart, ClipboardList, User, ShieldCheck } from "lucide-react";
import { useAuth } from "@/features/auth/AuthContext";
import { useCart } from "@/features/cart/CartContext";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/dashboard", label: "Hjem", icon: Home },
  { to: "/produkter", label: "Katalog", icon: LayoutGrid },
  { to: "/kurv", label: "Kurv", icon: ShoppingCart },
  { to: "/ordrer", label: "Ordrer", icon: ClipboardList },
  { to: "/konto", label: "Konto", icon: User },
] as const;

export function MobileNav() {
  // Sælgere/admins bruger primært admin i appen (køb sker via kundevisning),
  // så deres første fane er Admin i stedet for kunde-forsiden.
  const { isSalesperson } = useAuth();
  const { totalItems } = useCart();
  const tabs = isSalesperson
    ? ([{ to: "/admin", label: "Admin", icon: ShieldCheck }, ...TABS.filter((t) => t.to !== "/dashboard")] as const)
    : TABS;
  return (
    <nav
      aria-label="Mobilnavigation"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)] md:hidden"
    >
      <ul className="grid grid-cols-5">
        {tabs.map(({ to, label, icon: Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              aria-label={to === "/kurv" && totalItems > 0 ? `Kurv, ${totalItems} varer` : undefined}
              className={({ isActive }) =>
                cn(
                  "flex min-h-14 flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors",
                  isActive ? "font-bold text-navy" : "text-ink-3",
                )
              }
            >
              <span className="relative">
                <Icon className="h-5 w-5" aria-hidden />
                {to === "/kurv" && totalItems > 0 && (
                  <span
                    aria-hidden
                    className="absolute -right-2.5 -top-1.5 flex min-w-[17px] items-center justify-center rounded-full bg-brand px-1 py-0.5 text-[9px] font-bold leading-none text-white ring-2 ring-card"
                  >
                    {totalItems > 99 ? "99+" : totalItems}
                  </span>
                )}
              </span>
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
